import { UserVSRoleInsert, UserVSRoleInsertMany, UserVSRoleDelete, UserVSRoleUpdate, UserVSRoleGetById, UserVSRoleGetList, UserVSRoleGetPageList } from "@/api/uservsrole/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    UserVSRoleInsert(context, payload) {
        return new Promise((resolve, reject) => {
            UserVSRoleInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 新增
    UserVSRoleInsertMany(context, payload) {
        return new Promise((resolve, reject) => {
            UserVSRoleInsertMany(payload).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    UserVSRoleUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            UserVSRoleUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    UserVSRoleGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            UserVSRoleGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    UserVSRoleGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            UserVSRoleGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    UserVSRoleGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            UserVSRoleGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}